export default __webpack_public_path__ + "static/media/about.4b81b5c1.jpg";